export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative w-full min-h-[520px] md:min-h-[600px] flex items-center justify-center overflow-hidden scroll-mt-20"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20soft%20flowing%20organic%20shapes%20in%20very%20light%20warm%20cream%20and%20blush%20beige%20tones%20with%20subtle%20golden%20caramel%20accents%2C%20elegant%20beauty%20salon%20atmosphere%20texture%2C%20minimalist%20luxury%20background%20with%20gentle%20gradients%2C%20clean%20modern%20abstract%20design%20for%20wellness%20brand%2C%20no%20text%20no%20people%2C%20high%20quality%20artistic%20backdrop%20with%20warm%20ambient%20mood%20and%20soft%20dreamy%20aesthetic&width=1600&height=900&seq=saloons-hero-bg&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
          aria-hidden="true"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-white/70 via-white/40 to-background-50"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-16 md:py-20">
        <div className="max-w-3xl mx-auto text-center flex flex-col items-center gap-4 md:gap-5">
          <span className="inline-flex items-center gap-1.5 px-4 py-1.5 rounded-full bg-primary-50 border border-primary-200 text-xs md:text-sm font-medium text-primary-700">
            <span className="w-3.5 h-3.5 flex items-center justify-center">
              <i className="ri-verified-badge-fill text-primary-500 text-sm"></i>
            </span>
            15.000+ Doğrulanmış Yorum
          </span>

          <h1 className="text-3xl md:text-5xl lg:text-5xl font-extrabold text-foreground-900 leading-tight font-heading max-w-xl">
            Gerçek Müşteri<br />
            <span className="text-primary-500">Yorumlarımız</span>
          </h1>

          <p className="text-sm md:text-base text-foreground-500 max-w-md leading-relaxed">
            Saç, kalıcı makyaj, lazer epilasyon, cilt bakımı, gençleşme ve solaryum alanlarında
            binlerce <strong>gerçek müşteri</strong> deneyimi. Videolu yorumlarla şeffaf ve
            <strong> güvenilir</strong> bilgiye ulaşın.
          </p>

          <div className="flex flex-col sm:flex-row items-center gap-3 mt-2">
            <a
              href="#reviews"
              className="flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors duration-200 cursor-pointer whitespace-nowrap"
            >
              Yorumları İncele
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-down-line text-sm"></i>
              </span>
            </a>
            <a
              href="https://wa.me/905433724578?text=Merhaba%2C%20bilgi%20almak%20istiyorum."
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="flex items-center gap-2 px-6 py-3 rounded-full border border-primary-300 text-primary-600 font-medium text-sm hover:bg-primary-50 transition-colors duration-200 cursor-pointer whitespace-nowrap"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-whatsapp-fill text-base"></i>
              </span>
              WhatsApp ile Ulaşın
            </a>
          </div>

          <div className="flex items-center gap-6 mt-6 md:mt-8">
            <div className="flex flex-col items-center gap-1">
              <span className="text-xl md:text-2xl font-bold text-foreground-900 font-heading">15.000+</span>
              <span className="text-xs text-foreground-400">Mutlu Müşteri</span>
            </div>
            <div className="w-px h-8 bg-background-300"></div>
            <div className="flex flex-col items-center gap-1">
              <span className="text-xl md:text-2xl font-bold text-foreground-900 font-heading">4.9</span>
              <span className="text-xs text-foreground-400">Ortalama Puan</span>
            </div>
            <div className="w-px h-8 bg-background-300"></div>
            <div className="flex flex-col items-center gap-1">
              <span className="text-xl md:text-2xl font-bold text-foreground-900 font-heading">14+</span>
              <span className="text-xs text-foreground-400">Yıllık Deneyim</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}